<ul class="list-item-wrapper">
    <li>
        <div class="item-content">
            <div class="icon-bar-wrapper">
                <img [src]="idmsHierarchy.taggedItemType.icon" />
                {{ idmsHierarchy.taggedItemType.name }}
            </div>
            <div class="line-section-nested" *ngIf="idmsHierarchy.children"></div>
        </div>
        <mat-icon class="system_edit_icon" (click)="viewTaggedItemType(idmsHierarchy.taggedItemType)">remove_red_eye</mat-icon>
    </li>
    <ng-container *ngIf="idmsHierarchy?.children">
        <app-nested-render *ngFor="let taggedItem of idmsHierarchy?.children" [fullHierarchy]="idmsHierarchy" [idmsHierarchy]="taggedItem"></app-nested-render>
    </ng-container>
</ul>
